import {
  DatatablesFooterServerSide,
  InputOptionMaster,
  InputReactDatepicker,
  InputTextMaster,
  MasterButton,
  Modal,
  TableAction,
  TableCellDefault,
} from "App/Component/ui";
import { Grid, TableRow, TableCell } from "@material-ui/core";
import React, { useState } from "react";
import { defaultToastError, isNull, toDayIndo, today } from "App/utils/helpers";
import { getFilterModalBooking } from "../helpers";
import { useDatatables, useDatatablesServerSide } from "App/hooks";
import { useScehuldeDokter } from "../../../BookingAntrian/ui";
import { FreezeTable } from "components/organism";
import { getComparator, stableSort } from "App/Component/ui/datatable/utils";
import { useSelector } from "react-redux";

const ModalBooking = ({ setShowModal, handleClickSelect }) => {
  const [rows, setRows] = useState([]);
  const [formFilter, setFormFilter] = useState({
    name: "",
    doctor_id: "",
    doctor: "Pilih Dokter",
    dates: today(),
    schedule_doctor_id: "",
    id_booking: "",
    pages: 1,
    limit: 10,
  });
  const [totalData, setTotalData] = useState(0);

  const setNewData = async (
    pages = formFilter.pages,
    limit = formFilter.limit
  ) => {
    const scheduleDokterID = formFilter.schedule_doctor_id.includes("--");
    const scheduleDokterValid = scheduleDokterID
      ? formFilter.schedule_doctor_id.split("--")[0]
      : "";
    const res = await getFilterModalBooking(
      { ...formFilter, schedule_doctor_id: scheduleDokterValid },
      pages,
      limit
    );
    if (res.state) {
      setRows(res.data);
      setTotalData(res.meta.count);
    } else {
      setRows([]);
      defaultToastError(res.message);
    }
  };

  const handleChange = (text) => (e) => {
    setFormFilter({
      ...formFilter,
      [text]: e.target.value,
    });
  };

  const {
    pagination,
    onNext,
    onPrevious,
    handleClickPageNumber,
    handleChangeLimit,
    resetPagination,
  } = useDatatablesServerSide({ setNewData: setNewData });
  return (
    <Modal title={`Booking`} width='70%' show={setShowModal}>
      <FormFilterModalBooking
        setNewData={setNewData}
        formFilter={formFilter}
        setFormFilter={setFormFilter}
        handleChange={handleChange}
        resetPagination={resetPagination}
      />
      <div className='mt-2'>
        <TableListBooking rows={rows} handleClickSelect={handleClickSelect} />
        <DatatablesFooterServerSide
          totalData={totalData}
          pagination={pagination}
          handleChangeLimit={handleChangeLimit}
          onPrevious={onPrevious}
          onNext={onNext}
          currentPage={pagination.page}
          handleClickPageNumber={handleClickPageNumber}
        />
      </div>
    </Modal>
  );
};

export const defaultButtonSearch = {
  label: "CARI",
  color: "green",
  state: false,
};

export const urlGetDokter = "/doctor/listdoctor_regrj";
export const urlGetScheduleDokter = "/doctor/listscheduledoctor_id_regrj";

function FormFilterModalBooking({
  formFilter,
  setFormFilter,
  setNewData,
  handleChange,
  resetPagination,
}) {
  const master = useSelector(({ master }) => master);

  const scheduleDokter = useScehuldeDokter(formFilter.doctor_id);

  const handleSubmit = async (e) => {
    e.preventDefault();
    await setNewData(1, 10);
    resetPagination();
  };
  return (
    <form onSubmit={(e) => handleSubmit(e)}>
      <Grid container spacing={1}>
        <Grid item sm={2}>
          <InputTextMaster
            name='id_booking'
            label='ID BOOKING'
            id='id_booking'
            placeholder='ID BOOKING'
            value={formFilter.id_booking}
            onChange={handleChange("id_booking")}
          />
        </Grid>
        <Grid item sm={2}>
          <InputTextMaster
            name='name'
            label='NAMA'
            id='name'
            placeholder='Nama'
            value={formFilter.name}
            onChange={handleChange("name")}
          />
        </Grid>
        <Grid item sm={2}>
          <InputReactDatepicker
            selected={formFilter.dates}
            label='TANGGAL'
            handleChangeToday={(e) =>
              setFormFilter({
                ...formFilter,
                dates: e,
              })
            }
            onChange={(e) =>
              setFormFilter({
                ...formFilter,
                dates: e,
              })
            }
          />
        </Grid>
        <Grid item sm={4}>
          <InputOptionMaster
            name='doctor_id'
            label='DOKTER'
            id='doctor_id'
            withSearch={true}
            data={master.dokter.list_select}
            labelValue={formFilter.doctor}
            value={formFilter.doctor_id}
            onChange={(e) => {
              if (isNull(e)) {
                setFormFilter({
                  ...formFilter,
                  doctor_id: null,
                  doctor: "Pilih Dokter",
                  schedule_doctor_id: "",
                })
              } else {
                setFormFilter({
                  ...formFilter,
                  doctor_id: e.value,
                  doctor: e.label,
                  schedule_doctor_id: "",
                });
              }
            }}
          />
        </Grid>
        <Grid item sm={2}>
          <InputOptionMaster
            name='schedule_doctor_id'
            label='SCHEDULE DOKTER'
            id='schedule_doctor_id'
            withSearch={false}
            needParse={false}
            data={scheduleDokter}
            value={formFilter.schedule_doctor_id}
            onChange={handleChange("schedule_doctor_id")}
          />
        </Grid>
      </Grid>
      <Grid
        container
        direction='row'
        justifyContent='flex-end'
        alignItems='center'>
        <MasterButton
          name={"CARI"}
          outline={true}
          className='mt-1'
          color={"green"}
          type={"submit"}
          size={"md"}
        />
      </Grid>
    </form>
  );
}

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "id",
    disablePadding: false,
    label: "ID BOOKING",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "name",
    disablePadding: false,
    label: "NAMA",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "rm_id",
    disablePadding: false,
    label: "ID RM",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "nama_dokter",
    disablePadding: false,
    label: "Dokter",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "jadwal",
    disablePadding: false,
    label: "JADWAL PRAKTEK",
    align: "left",
    minWidth: "210px",
  },
  {
    id: "mobile_phone",
    disablePadding: false,
    label: "NO HP",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "nik",
    disablePadding: false,
    label: "NIK",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "inserted_time",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "inserted_by",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updated_time",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "updated_by",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
];

const TableListBooking = ({ rows, handleClickSelect }) => {
  const { order, orderBy, length, handleRequestSort } = useDatatables({
    rows: rows,
    orderByDefault: "id",
    orderByRow: ["id"],
  });

  return (
    <FreezeTable
      headCells={headCells}
      handleRequestSort={handleRequestSort}
      order={order}
      length={length}
      orderBy={orderBy}>
      {stableSort(rows, getComparator(order, orderBy)).map((row, index) => {
        return (
          <TableRow hover key={index}>
            <TableCell align='center'>{index + 1}</TableCell>

            <TableCell align='center'>
              <TableAction
                isDelete={false}
                isUpdate={false}
                isSelect={true}
                clickSelect={() => handleClickSelect(row)}
              />
            </TableCell>
            <TableCell align='left'>{row?.id}</TableCell>
            <TableCell align='left'>{row?.name}</TableCell>
            <TableCell align='left'>{row?.rm_id}</TableCell>
            <TableCell align='left'>{row?.nama_dokter}</TableCell>
            <TableCell align='left'>
              {toDayIndo(row?.day)}, {row?.time_start} {row?.time_finish} ({row?.status_jadwal_string})
            </TableCell>
            <TableCell align='left'>{row?.mobile_phone}</TableCell>
            <TableCell align='left'>{row?.nik}</TableCell>
            <TableCellDefault row={row} />
          </TableRow>
        );
      })}
      {rows.length === 0 && (
        <TableRow>
          <TableCell align='center' colSpan={headCells.length}>
            Tidak ada data
          </TableCell>
        </TableRow>
      )}
    </FreezeTable>
  );
};

export default ModalBooking;
